import regionalRestrictionsSaga from "../regional-restrictions-saga";

export default regionalRestrictionsSaga;
